// extracted by mini-css-extract-plugin
export default {"root":"dm_3K9S8zPYBDAHWjgft"};